import React, { useState } from "react";
import { Box } from "../../../components/styled/Elements";
import { sentReqColumns } from "../../../helpers/adminConstants/TableConstants";
import {
  PaginationContainer,
  TableWrapper,
} from "../../../components/common/tables/ListTable";
import { useTranslation } from "react-i18next";
import CancelReqModal from "../../../components/admin/Modals/CancelReqModal/CancelReqModal";
import Pagination from "react-js-pagination";
import { NoRecord } from "../../../components/admin/NoRecord/NoRecord";

const SentRequests = ({
  sentReqsRows,
  totalCount,
  perPage,
  activePage,
  setActivePage,
  acceptRejectRequest,
}) => {
  const [cancelModal, setCancelModal] = useState(false);
  const [requestId, setRequestId] = useState(null);
  const { t } = useTranslation();

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  return (
    <Box>
      <TableWrapper>
        <Box className="table-responsive custom-scroll overflow-x-auto">
          <table className="w-100 ">
            <thead>
              <tr>
                {sentReqColumns.map((col, key) => (
                  <th key={key} className="text-nowrap">
                    {t(col.label)}
                  </th>
                ))}
              </tr>
            </thead>
            {sentReqsRows && sentReqsRows.length > 0 ? (
              <tbody>
                {sentReqsRows?.map((row, index) => (
                  <tr key={index}>
                    {sentReqColumns?.map((col, key) => (
                      <td key={key}>
                        {col.render
                          ? col.render(
                              row[col.name],
                              row,
                              t,
                              setCancelModal,
                              setRequestId
                            )
                          : col.name === "id"
                          ? (activePage - 1) * perPage + index + 1
                          : row[col.name]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td colSpan="100%">
                    <NoRecord />
                  </td>
                </tr>
              </tbody>
            )}
          </table>
        </Box>
        {totalCount && (
          <PaginationContainer>
            <Pagination
              itemClass="page-item"
              linkClass="page-link"
              activePage={activePage}
              itemsCountPerPage={perPage}
              totalItemsCount={totalCount}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
            />
          </PaginationContainer>
        )}
      </TableWrapper>
      <CancelReqModal
        show={cancelModal}
        onHide={() => setCancelModal(false)}
        requestId={requestId}
        acceptRejectRequest={acceptRejectRequest}
      />
    </Box>
  );
};

export default SentRequests;
